import { render } from "./ServiceComp.vue?vue&type=template&id=0eec6f7f"
import script from "./ServiceComp.vue?vue&type=script&lang=js"
export * from "./ServiceComp.vue?vue&type=script&lang=js"

import "./ServiceComp.vue?vue&type=style&index=0&id=0eec6f7f&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__